<div class="skl-card" aria-busy="true" aria-label="Loading POD table">
  <div class="skl-card__body">
    <div class="skl-table-wrap">
      <div class="table-responsive">
        <table class="skl-table">
          <colgroup>
            <col style="width: 15%">
            <col style="width: 42%">
            <col style="width: 15%">
            <col style="width: 28%">
          </colgroup>
          <thead>
            <tr>
              @for (width of ['24%', '38%', '18%', '20%']; track width) {
                <th>
                  <app-skeleton [width]="width" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row) {
              <tr>
                <td><app-skeleton [width]="row % 2 === 0 ? '34%' : '28%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                <td><app-skeleton [width]="row % 2 === 0 ? '72%' : '64%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton></td>
                <td><app-skeleton width="54px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton></td>
                <td>
                  <div class="skl-actions-inline">
                    <app-skeleton width="54px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                    <app-skeleton width="64px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="skl-pagination">
      <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
      <div class="skl-pagination__buttons">
        @for (btn of [1, 2, 3, 4]; track btn) {
          <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
        }
      </div>
    </div>
  </div>
</div>